export const TEST_ID = 'informationNotification';
